import { Dispatch, SetStateAction } from 'react';

import { optionsFormattedFromEnum } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { TTableFilter } from '@interfaces/components/table';

import { ERequestItemApprovalStatuses } from '@enums/asset';

export function getFilters({
	selectedAssetType,
	setSelectedAssetType,
	selectedApprovalStatus,
	setSelectedApprovalStatus,
	assetTypes = [],
}: {
	selectedAssetType: TSelectOption;
	setSelectedAssetType: Dispatch<SetStateAction<TSelectOption<string>>>;
	selectedApprovalStatus: TSelectOption<string>;
	setSelectedApprovalStatus: Dispatch<SetStateAction<TSelectOption<string>>>;
	assetTypes: Array<TSelectOption<string>>;
}): Array<TTableFilter> {
	return [
		{
			name: 'Asset Type',
			placeholder: 'Asset type',
			option: selectedAssetType,
			options: assetTypes,
			minWidth: '200px',
			setState: setSelectedAssetType,
			defaultValue: 'All',
		},
		{
			name: 'approvalStatus',
			placeholder: 'Approval Status',
			option: selectedApprovalStatus,
			options: optionsFormattedFromEnum(ERequestItemApprovalStatuses),
			minWidth: '200px',
			setState: setSelectedApprovalStatus,
			defaultValue: 'All',
		},
	];
}
